/*
 * @Author: LiJunLei 2826904107@qq.com
 * @Date: 2023-01-05 08:59:05
 * @LastEditors: LiJunLei 2826904107@qq.com
 * @LastEditTime: 2023-01-05 10:33:58
 * @FilePath: \emergency-h5\src\api\request\eventCenter\isTisk.js
 */
import requests from '@/api/request'
import Cookie from "js-cookie";
let BASE_URL = `api`
let api = {
    getList: `${BASE_URL}/emergencyevent/process/task/pagelist`,//分页查询下派任务
    isTaskFinish: `${BASE_URL}/emergencyevent/process/task/update`,//分页查询下派任务
}
// 查询
export async function getIstiskList(data) {
    return requests({
        url: api.getList,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}
//完成下派
export async function isTaskFinishAPI(data) {
    return requests({
        url: api.isTaskFinish,
        method: 'post',
        data,
        headers: {
            token: Cookie.get("tokenAdmin"),
        }
    }
    )
}